import React from "react";
import cardGroup2 from "../modules/layout/CardGroup2";
import CardGroup2 from "../modules/layout/CardGroup2";

const contents = [
  {
    title: "전자기기 전원 OFF",
    component: (
      <>
        평가에 응시할 때는 휴대전화 및
        <br />
        각종 전자기기의 전원을
        <br />
        반드시 꺼 주세요.
      </>
    ),
  },
  {
    title: "메모 금지",
    component: (
      <>
        평가 중에는 필기도 사용 및
        <br />
        메모를 금지합니다.
      </>
    ),
  },
  {
    title: "기타 유의사항",
    component: (
      <>
        본 시험은 컴퓨터를 이용한
        <br />
        인터넷 기반의 평가로
        <br />
        네트워크 등의 오류로 인하여 시험 진행 중
        <br />
        일시적인 지연이 있을 수 있습니다.
      </>
    ),
  },
];

const GuideCardGroup2 = () => {
  return <CardGroup2 contents={contents} />;
};

export default GuideCardGroup2;
